<div class="body">

  <div class="x4">
    <div class="cloud"></div>
  </div>

  <div class="cloud-glow" id="box" data-type="white_2">
    <div class="heading">
      <h1>Welcome to</h1>
      <h1>MitchellHenschel.com</h1>
    </div>
  </div>

    <div class="x2">
      <div class="cloud"></div>
    </div>

    <div class="x4">
      <div class="cloud"></div>
    </div>

    <div class="x5">
      <div class="cloud"></div>
    </div>
</div>
